module.exports = __webpack_public_path__ + "static/media/familyMember.4e87fc3e.svg";